import { all, fork } from 'redux-saga/effects';
import { watchAuth } from '../auth';
import { watchProjects } from '../projects';
import { watchTasks } from '../tasks';
import { watchTags } from '../tags';
import { watchComments } from '../comments';
import { watchDashboard } from '../dashboard';
import { watchUsers } from '../users';
import { watchLabor } from '../labor';

export function* appSaga() {
  yield all([
    fork(watchAuth),
    fork(watchProjects),
    fork(watchTasks),
    fork(watchTags),
    fork(watchComments),
    fork(watchDashboard),
    fork(watchUsers),
    fork(watchLabor),
  ]);
}
